enum ContactDetailEnum {
    WhatsApp = "https://wa.me/541161550202?text=%D0%A5%D0%BE%D1%87%D1%83%20%D0%BF%D0%BE%D0%BB%D1%83%D1%87%D0%B8%D1%82%D1%8C%20%D0%BA%D0%BE%D0%BD%D1%81%D1%83%D0%BB%D1%8C%D1%82%D0%B0%D1%86%D0%B8%D1%8E%20%D0%BF%D0%BE%20%D1%81%D0%BE%D0%BF%D1%80%D0%BE%D0%B2%D0%BE%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8E%20%D1%80%D0%BE%D0%B4%D0%BE%D0%B2%20%D0%B2%20%D0%90%D1%80%D0%B3%D0%B5%D0%BD%D1%82%D0%B8%D0%BD%D0%B5%21",
    Telegram = "https://t.me/olga_buenos",
    Instagram = "https://www.instagram.com/olga.buenos/",
    WhatsAppCompoundHttpsAndNumber = "https://wa.me/541161550202?text="
}

export default ContactDetailEnum;